// extracted by mini-css-extract-plugin
module.exports = {"root":"ToggleInLibraryDialog_root__dZtGS","checkbox":"ToggleInLibraryDialog_checkbox__6k2Q0"};